import {
    calcularQtdDependentesHumanos,
    calcularQtdDependentesPet,
    calcularQtdDependentesEspeciaisHumanos,
} from './funcoesAuxiliaresZPC';

export class CorrenteEdicaoZPC {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
    }
    infringeTipoDependente() {
        if (
            (this.valoresAnterioresForm.Parentesco.trim() === 'PET' &&
                this.valoresForm.Parentesco.trim() !== 'PET') ||
            (this.valoresAnterioresForm.Parentesco.trim() !== 'PET' &&
                this.valoresForm.Parentesco.trim() === 'PET')
        ) {
            this.arrayMsgsErro.push(
                'Não é possível alterar o tipo de dependente. Caso seja necessário, exclua e cadastre o dependente novamente com o tipo correto.'
            );
        }
        return this;
    }
    infringeAdicionalPet() {
        if (
            this.valoresForm.Parentesco.trim() === 'PET' && this.valoresForm.Categoria.trim() === 'ZELO'  
        ) {
            this.arrayMsgsErro.push(
                'Não é permitido dependente do tipo PET sem valor adicional.'
            );
        }
        return this;
    }
    infringeAdicionalPetPrime() {
        if (
            this.valoresForm.Parentesco.trim() !== 'PET' && this.valoresForm.Categoria.trim() === 'ZPETA'  
        ) {
            this.arrayMsgsErro.push(
                'O adicional ZELO PET PRIME é permitido apenas para dependentes do tipo PET.'
            );
        }
        return this;
    }
    infringeQuantidadeDependentesSemValorAdicional() {
        const qtdDependentesTotais = calcularQtdDependentesHumanos(this.dependentes);
        const qtdDependentesEspeciais = calcularQtdDependentesEspeciaisHumanos(this.dependentes);
        const qtdDependentesRegra  = qtdDependentesTotais - qtdDependentesEspeciais
        if (qtdDependentesRegra === 4 &&
            this.valoresForm.Parentesco.trim() !== 'PET' &&
            (this.valoresAnterioresForm.Categoria === 'ZP26' && this.valoresForm.Categoria === 'ZELO')) {
            this.arrayMsgsErro.push('Este plano permite apenas 4 dependentes HUMANOS sem valor adicional.')
        }
        return this;
    }
    infringeQuantidadeDependenteEspeciais() {
        const qtdDependentesEspeciais = calcularQtdDependentesEspeciaisHumanos(this.dependentes);
        if (qtdDependentesEspeciais === 1 &&
            this.valoresForm.Parentesco.trim() !== 'PET' &&
            (this.valoresAnterioresForm.Categoria === 'ZELO' && this.valoresForm.Categoria === 'ZP26')) {
            this.arrayMsgsErro.push('Este plano permite apenas 1 dependente especial HUMANO.')
        }
        return this;
    }
}
